import { Grid, Skeleton } from '@mui/material'
import { FC } from 'react'

interface Props {}

export const MemberShipLoader: FC<Props> = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Skeleton variant="rounded" width={250} height={300} />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant="rounded" width={250} height={300} />
      </Grid>
    </Grid>
  )
}
